import { render, staticRenderFns } from "./videoDiv.vue?vue&type=template&id=0539533b&scoped=true&"
import script from "./videoDiv.vue?vue&type=script&lang=js&"
export * from "./videoDiv.vue?vue&type=script&lang=js&"
import style0 from "./videoDiv.vue?vue&type=style&index=0&id=0539533b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0539533b",
  null
  
)

export default component.exports